import React, { useState } from 'react'
import i18n from 'i18n-js'

import Input from '../../../UI/Input/Input'
import './SearchForm.scss'

const SearchForm = props => {

    const [filtered, setFiltered] = useState(props.monsters)

    const [searchInput, setSearchInput] = useState({
        type: 'text',
        id: 'search',
        value: '',
        label: i18n.t('search'),
        placeholder: i18n.t('search'),
        maxLength: 39,
        hideLabel: true
    })

    const onFilterResults = evt => {
        // console.log('onFilterResults', evt)
        const val = evt.target.value
        const filtermobs = props.monsters.filter(el => {
            const name = el.name
            return name.toLowerCase().startsWith(val.toLowerCase())
        })
        setSearchInput({
            ...searchInput,
            value: val
        })
        setFiltered(filtermobs)
    }

    return <div className="SearchForm">
        <Input {...searchInput} changed={evt => onFilterResults(evt)} />
        <div className="scroll-wrapper">
            <ul className="monsters-list">
                {filtered.map(el => {
                    return <li key={el.name} onClick={() => props.selected(el.name)}>{el.name}</li>
                })}
            </ul>
        </div>
        <button type="button" className="back-button" onClick={props.back}>{i18n.t('back')}</button>
    </div>
}

export default SearchForm